export const JOIN_TO_PAYMENT_SOCKET_EVENT = 'joinToPayment';
export const LEAVE_FROM_PAYMENT_SOCKET_EVENT = 'leaveFromPayment';
export const PAYMENT_STATUS_SOCKET_EVENT = 'payment_status';